import React from "react";

// Adapted from VendorInvoices/components/table/PaginationFooter.js — the
// contracts slice stores pagination fields flat (count/currentPage/pageSize/
// nextPage/previousPage) rather than nested under a `pagination` key.
const ContractPaginationFooter = ({ count, currentPage, pageSize, nextPage, previousPage, loading, onPrev, onNext }) => {
  const showingFrom = !count ? 0 : (currentPage - 1) * pageSize + 1;
  const showingTo = !count ? 0 : Math.min(currentPage * pageSize, count);

  const label = loading
    ? "Loading..."
    : !count
    ? "No contracts"
    : `Showing ${showingFrom}–${showingTo} of ${count} contracts`;

  return (
    <div className="d-flex align-items-center justify-content-between px-3 py-2 border-top bg-light">
      <span className="small text-muted">{label}</span>
      <div className="d-flex gap-2">
        <button
          className="btn btn-sm btn-outline-secondary"
          disabled={!previousPage}
          onClick={() => onPrev(previousPage)}
        >
          Previous
        </button>
        <button
          className="btn btn-sm btn-outline-secondary"
          disabled={!nextPage}
          onClick={() => onNext(nextPage)}
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default ContractPaginationFooter;
